import { RootState } from 'modules'

export const selectWriting = (state: RootState): string | null => state.writing
